import { useContext, useEffect, useState } from 'react'
import { AppContext } from '../context/AppContext'
import { IStore } from '../types/IStore'
import { getChosenStore, setChosenStore } from '../utils/currentStoreStorage'

const nullStore: IStore = {
  storeCode: '',
  storeName: undefined,
  inScope: false
}

const useCurrentStore = (): IStore => {
  const context = useContext(AppContext)
  const [store, setStore] = useState(() => {
    if (context && context.store !== undefined) {
      return context.store
    }

    return getChosenStore() ?? nullStore
  })

  useEffect(() => {
    if (context && context.store !== undefined) {
      setStore(context.store)
      setChosenStore(context.store)
    }
  }, [context?.store])

  return store
}

export default useCurrentStore
